/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numbers (0-9)`)
};

const es_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números (0-9)`)
};

const de_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen (0-9)`)
};

const nl_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getallen (0-9)`)
};

const fr_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiffres (0-9)`)
};

const it_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numeri (0-9)`)
};

const pt_br2_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números (0-9)`)
};

const pt_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números (0-9)`)
};

const ja_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字 (0-9)`)
};

const zh_pw_digits = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字 (0-9)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_digits = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_digits(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_digits", locale)
	if (locale === "en") return en_pw_digits(inputs)
	if (locale === "es") return es_pw_digits(inputs)
	if (locale === "de") return de_pw_digits(inputs)
	if (locale === "nl") return nl_pw_digits(inputs)
	if (locale === "fr") return fr_pw_digits(inputs)
	if (locale === "it") return it_pw_digits(inputs)
	if (locale === "pt-BR") return pt_br2_pw_digits(inputs)
	if (locale === "pt") return pt_pw_digits(inputs)
	if (locale === "ja") return ja_pw_digits(inputs)
	return zh_pw_digits(inputs)
};